/** Grouped recurring-risk review window copy — resolved from ReviewWindowContext. */

import type { ReviewWindowContext } from './reviewWindowContext';
import {
  formatObservationBadge,
  formatObservationCountLine,
  formatReviewWindowHeaderLabel,
  reviewWindowUsesLast24hPreset,
} from './reviewWindowContext';

/**
 * @deprecated Use resolveReviewWindowContext + formatReviewWindowHeaderLabel.
 * Kept for tests migrating off hardcoded defaults — not a production display default.
 */
export const GROUPED_REVIEW_WINDOW_LABEL = 'Last 24h';

/**
 * Volume shown on grouped review badges: selected review window only,
 * not persisted episode / 7-day lookback totals.
 */
export function resolveGroupedReviewWindowDisplayCount(
  windowSignalCount: number,
  patternVolumeCount: number,
): number {
  const window = Math.max(0, Number(windowSignalCount) || 0);
  const volume = Math.max(0, Number(patternVolumeCount) || 0);
  if (window > 0) return window;
  return volume;
}

/** @deprecated Use formatReviewWindowHeaderLabel(reviewWindowContext). */
export function formatGroupedReviewWindowSummary(ctx: ReviewWindowContext): string {
  return formatReviewWindowHeaderLabel(ctx);
}

/**
 * When linked-record volume exceeds this, prefer explicit scope copy over preset labels.
 */
export const GROUPED_REVIEW_WINDOW_HIGH_VOLUME_THRESHOLD = 10_000;

/** @deprecated Use formatObservationBadge with ReviewWindowContext. */
export function groupedReviewWindowVolumeSuffix(
  count: number,
  ctx: ReviewWindowContext,
): string {
  const n = Math.max(0, Number(count) || 0);
  if (n > GROUPED_REVIEW_WINDOW_HIGH_VOLUME_THRESHOLD) {
    return 'selected review window';
  }
  if (reviewWindowUsesLast24hPreset(ctx)) {
    return 'Last 24h';
  }
  return 'selected review window';
}

/** Top status-row badge — scope-aware observation count. */
export function formatGroupedRecurringRiskVolumeBadge(
  count: number,
  reviewWindowContext: ReviewWindowContext,
): string {
  return formatObservationBadge(count, reviewWindowContext);
}

/** Read-side scope line for grouped pattern summary panels. */
export function formatGroupedPatternVolumeReadLine(
  count: number,
  reviewWindowContext: ReviewWindowContext,
): string {
  return formatObservationCountLine(count, reviewWindowContext);
}
